// 덴클 프로그램(에이전트) 버전에 따라 3D 모델 요청이 빠지는지 (대표 2026-11-02 "웹에서도 모델 빠진 거 알 수 있게")
//   config/features.modelOpenAll(11-02 전체 열림)은 에이전트 alpha.122 부터 읽는다. alpha.121 이하는 예전 허용 목록(modelAllowedLabIds)만 봐서,
//   목록에 없는 기공소면 "3D 모델 준비 중"으로 보고 모델을 빼고 지그만 보낸다(웹엔 "지그 + 모델"이 보이는데 모델이 조용히 빠짐).
//   순수 함수 — 화면(Jig.js·JigPcCases.js)과 시험(__tests__/agentModelSupport.test.js)이 같이 쓴다.

export const MODEL_OPEN_ALL_MIN_ALPHA = 122;

/** '1.0.0-alpha.121' → 121, 'v1.0.0-alpha.99' → 99, 모르면 0 (문자열 비교는 alpha.99 > alpha.121 로 틀린다) */
export function alphaOf(version) {
    const m = String(version || '').match(/alpha\.(\d+)/);
    return m ? Number(m[1]) : 0;
}

/**
 * 이 PC 가 모델 요청을 빼는지 — true 일 때만 경고한다. 버전을 모르면(0) false(괜히 겁주지 않음).
 * @param {string} version PC 의 덴클 프로그램 버전
 * @param {object|null} features config/features
 * @param {string} labId 기공소
 */
export function pcDropsModel(version, features, labId) {
    const a = alphaOf(version);
    if (!a || a >= MODEL_OPEN_ALL_MIN_ALPHA) return false;
    const f = features || {};
    if (f.modelOpenAll !== true) return false;   // 전체 열림이 아니면 옛 버전도 서버와 같은 목록을 본다
    const ids = Array.isArray(f.modelAllowedLabIds) ? f.modelAllowedLabIds : [];
    return !ids.includes(labId);                 // 목록에 있던 기공소는 옛 버전도 모델을 만든다
}

export const dropModelText = (version) =>
    `이 PC의 덴클 프로그램(${version || '옛 버전'})은 3D 모델을 만들지 못해 모델을 빼고 지그만 보냅니다. alpha.${MODEL_OPEN_ALL_MIN_ALPHA} 이상으로 업데이트해 주세요.`;
